import { render, staticRenderFns } from "./HotelHighlightItemList.vue?vue&type=template&id=1e1a41a9&"
import script from "./HotelHighlightItemList.vue?vue&type=script&lang=js&"
export * from "./HotelHighlightItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports